export default __webpack_public_path__ + "static/media/one.d63a36af.jpg";